module.exports = __webpack_public_path__ + "static/media/mobile-instruction4.e68499d6.jpg";